import { useContext } from 'react'
import { SearchContext } from '../containers/contexts/search'

export const useAccountSearch = () => {
  const { accountSearchState, searchAccounts } = useContext(SearchContext)
  return { accountSearchState, searchAccounts }
}
